import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SeoHead from '@/components/base/SeoHead';
import CelebrationBanner from '@/components/feature/CelebrationBanner';
import HeroSection from './components/HeroSection';
import FeatureStrip from './components/FeatureStrip';
import ProductShowcase from './components/ProductShowcase';
import StatsSection from './components/StatsSection';
import AboutSection from './components/AboutSection';
import TestimonialsSection from './components/TestimonialsSection';
import DealerCTA from './components/DealerCTA';
import ProductLaunchSection from './components/ProductLaunchSection';
import { useTheme } from '@/context/ThemeContext';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Stingray — Global Marine Power',
  description: 'Premium lithium LiFePO4, AGM and gel marine batteries trusted by boaters in 50+ countries. Engineered for performance and reliability on every ocean.',
  url: 'https://stingray-marine.com/',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [{ '@type': 'ListItem', position: 1, name: 'Home', item: 'https://stingray-marine.com/' }],
  },
};

export default function HomePage() {
  const { theme } = useTheme();
  const light = theme === 'light';

  return (
    <div className={`min-h-screen transition-colors duration-300 ${light ? 'bg-gray-50' : 'bg-[#0D1B2A]'}`}>
      <SeoHead
        title="Stingray | Lithium LiFePO4, AGM &amp; Gel Marine Batteries | Global Marine Power"
        description="Stingray — premium lithium LiFePO4, AGM and gel marine batteries trusted by boaters in 50+ countries. High-performance marine battery solutions for every vessel and ocean."
        keywords="marine battery, lithium marine battery, LiFePO4 marine battery, AGM marine battery, gel marine battery, Stingray battery, deep cycle marine battery"
        canonical="https://stingray-marine.com/"
        schema={homeSchema}
      />
      <CelebrationBanner />
      <Navbar />
      <main>
        <HeroSection />
        <FeatureStrip />
        <ProductShowcase />
        <ProductLaunchSection />
        <StatsSection />
        <AboutSection />
        <TestimonialsSection />
        <DealerCTA />
      </main>
      <Footer />
    </div>
  );
}
